<template>
  <el-form
    label-position="top"
    :model="form"
    class="integration-form"
    :label-width="'100%'"
  >
    <el-row :gutter="20">
      <el-col
        v-for="field in fields"
        :key="field.key"
        :xs="24"
        :sm="24"
        :md="24"
        :lg="24"
      >
        <el-form-item :label="field.label">
          <el-select
            v-if="field.type === 'select'"
            v-model="form[field.key]"
            :placeholder="field.placeholder || 'Select an option'"
            filterable
            clearable
            class="full-width"
            @change="loadDependentFields(field)"
          >
            <el-option
              v-for="option in field.values"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row justify="end" style="margin-top: 20px">
      <el-col :span="24">
        <el-button type="primary" @click="handleSave" class="save-btn"
          >Save</el-button
        >
      </el-col>
    </el-row>
  </el-form>
  <br />
</template>
<script>
import axios from "@/store/modules/axiosInstance";
export default {
  props: {
    application: Object,
    connection: Object,
    fields: Array,
  },
  data() {
    return {
      form: {},
    };
  },
  mounted() {
    this.loadRequiredData(this.fields, this.application, this.connection._id);
    this.connectionUpdate();
  },
  methods: {
    connectionUpdate() {
      if (this.connection) {
        this.form = this.connection.dependencies
          ? this.connection.dependencies
          : {};
      }
      return;
    },
    async handleSave() {
      await this.UpdateConnectionInfo();
      window.open(
        `${this.$route.query.redirect_url}?state=${this.$route.query.state}`,
        "_self"
      );
    },
    async loadDependentFields(field) {
      try {
        let activeDependencies = [];
        this.fields.forEach((item) => {
          if (
            item.dependencyField &&
            item.dependencyField.includes(field.key)
          ) {
            item.dependencyField.map((value) => {
              let isActiveDependentField = false;
              if (!this.form[value]) {
                isActiveDependentField = false;
              } else {
                isActiveDependentField = true;
              }
              if (isActiveDependentField) {
                activeDependencies.push(item);
              }
            });
          }
        });
        if (activeDependencies.length) {
          await Promise.all(
            activeDependencies.map(async (field) => {
              let payload = {
                appName: this.application.name,
                connectionId: this.connection._id,
                field: field.key,
                parameters: this.form,
              };
              let response = await this.getIntegrationRequiredData(payload);
              field.values = response.data;
              return response.data;
            })
          );
        }
        return;
      } catch (err) {
        return err;
      }
    },
    async getIntegrationRequiredData(payload) {
      try {
        const response = await axios.post(
          "/integrations/get-required-fields",
          payload
        );
        return response.data;
      } catch (err) {
        return err;
      }
    },
    async UpdateConnectionInfo() {
      try {
        const response = await axios.post(
          `/integrations/update_connection/${this.connection._id}`,
          { form: this.form }
        );
        return response.data;
      } catch (err) {
        return err;
      }
    },
    async loadRequiredData(fields, application, connectionId) {
      try {
        if (fields && fields.length) {
          let filterNoDependencyFields = fields.filter(
            (field) => field.dependencyField?.length === 0
          );
          await Promise.all(
            filterNoDependencyFields.map(async (ndpField) => {
              let payload = {
                appName: application.key,
                connectionId: connectionId,
                field: ndpField.key,
              };
              let response = await this.getIntegrationRequiredData(payload);
              if (response?.data) {
                ndpField["values"] = response.data;
              }
            })
          );
          return;
        }
      } catch (err) {
        return err;
      }
    },
  },
};
</script>
<style scoped>
.integration-form {
  width: 100%;
}
.full-width {
  width: 100%;
}
.save-btn {
  width: 100%;
}
</style>
